module.exports = __webpack_public_path__ + "static/img/aqzs33.800401d8.jpg";